interface QueryParamsObject {
  [key: string]: string;
}

export const queryStringFromParams = (params: object) => {
  if (!params) {
    return "";
  }

  if (typeof params !== "object" || Array.isArray(params)) {
    throw new Error(`Expected "params" to be an "object" got ${params}`);
  }

  let queryString = "";

  const keys = Object.keys(params);

  if (!(keys.length > 0)) {
    return queryString;
  }

  queryString = "?";
  const queryStringPairs: string[] = [];
  keys.sort().forEach((key: string) => {
    queryStringPairs.push(`${key}=${encodeURIComponent(params[key])}`);
  });

  return `${queryString}${queryStringPairs.join("&")}`;
};

export const queryStringObjectFromUrl = (url: string = "") => {
  const queryString = url.split("?")[1];
  const params = new URLSearchParams(queryString);
  let result: QueryParamsObject = {};
  params.forEach((val, key) => {
    result[key] = val;
  });
  return result;
};

interface UpdatedUrlProps {
  url: string,
  slug?: string,
  parentId?: string,
  childId?: string,
}

export const getUpdatedUrl = ({ url, slug, parentId, childId }: UpdatedUrlProps) => {
  if (slug) {
    url = url.replace("{slug}", slug);
  }
  if (parentId) {
    url = url.replace("{id}", parentId);
  }
  if (childId) {
    url = url.replace("{childId}", childId);
  }

  return url;
};

export const getUrlWithParamsWithoutHost = (url = "", params) => {
  if (!url) {
    return "";
  }
  try {
    const hostIndex = url.indexOf(".com/");
    if (hostIndex > -1) {
      url = url.substr(hostIndex + 5);
    }
    if (params) {
      const paramSeparator = (url.indexOf("?") > -1) ? ("&") : ("?");
      url += paramSeparator + params;
    }
  } catch (error) {
    throw error;
  }
	return url;
};


export const appendQueryStringToUrl = (url: string, queryString: string = "") => {
  if (!url) {
    throw new Error('"url" can not be empty');
  }

  const queryStringExists = (url.indexOf("?") > -1);
  const modifiedUrl = `${url}${ (queryStringExists) ? "&" : "?" }${queryString}`;

  return modifiedUrl;
};


interface RecommendationUrlProps {
  slug: string;
  childId?: string;
  root: string;
};

export const getRecommendationsUrl = ({
  slug,
  childId,
  root,
}: RecommendationUrlProps) => {
  const queryString = `root=${root}${childId ? `&skuId=${childId}` : ""}`;
  const productUrl = `/${appendQueryStringToUrl(slug, queryString)}`;

  return productUrl;
};

